<template>
  <el-button :type="buttontype" icon="el-icon-circle-plus-outline" @click="JumpTo">{{buttonname}}</el-button>
</template>

<script>
export default {
  name: 'AddButton',
  props: {
    url: {
      type: String
    },
    buttonname: {
      type: String,
      default: '新增'
    },
    buttontype: {
      type: String,
      default: 'primary'
    }
  },
  methods: {
    JumpTo: function () {
      this.$router.push('/main' + this.url)
    }
  }
}
</script>

<style>
</style>
